// extracted by mini-css-extract-plugin
module.exports = {"extra":"index_extra_2aFSh","assetSelect":"index_assetSelect_3-IQH"};